import { IDENTITIES_KEYS_SPECIAL } from '../types';
import { isObject } from './utils';
import { getStorageItem } from './storage';
import { validateValueType } from './identities';
import { getExtendedLoginFromWindowObject } from './externals/login';
import { debug } from './debug';
/**
 * Special "identities" / "identities parts" (rusId, premium, said, ...) can be stored via public api
 * We need to wrap them in to main identity (login) before storing
 */
export const createValueForSpecial = (identificator, value, specials) => {
    // validate
    const valueValidated = validateValueType(identificator, value);
    if (!valueValidated.ok) {
        debug({
            type: 'error',
            message: `Submited value for identity (${identificator}) is invalid`,
            value,
        });
        return null;
    }
    const _canStoreSpecial = (identificator) => {
        var _a;
        if (getExtendedLoginFromWindowObject()) {
            return false;
        }
        else if (identificator === IDENTITIES_KEYS_SPECIAL.login && specials.login) {
            // TODO - is existing only in cache -> allow and start with empty login object
            return false;
        }
        else if (((_a = specials.login) === null || _a === void 0 ? void 0 : _a[identificator]) !== undefined) {
            // TODO - is existing only in cache -> allow and start with empty login object
            return false;
        }
        return true;
    };
    // login -> rusId, premium, said, state, pid, ...
    if (identificator in IDENTITIES_KEYS_SPECIAL) {
        // "specials" key not existing -> get current storage values
        if (!isObject(specials.login)) {
            specials.login = (getStorageItem('login', {
                rich: false,
                cacheEnough: true,
                justSettled: false,
            }) || {});
        }
        // setting {rusId: "value"} -> sets {uid: "value"}
        if (identificator === IDENTITIES_KEYS_SPECIAL.rusId && _canStoreSpecial(identificator) && valueValidated.value) {
            specials.login.uid = valueValidated.value;
            return 'login';
        }
        // setting {said: "value"} -> sets {advert_uid: "value", said: "value"}
        if (identificator === IDENTITIES_KEYS_SPECIAL.said && _canStoreSpecial(identificator)) {
            specials.login.advert_uid = valueValidated.value;
            specials.login.said = valueValidated.value;
            return 'login';
        }
        if (identificator === IDENTITIES_KEYS_SPECIAL.premium && _canStoreSpecial(identificator)) {
            specials.login.premium = valueValidated.value;
            return 'login';
        }
        if (identificator === IDENTITIES_KEYS_SPECIAL.sbr && _canStoreSpecial(identificator)) {
            specials.login.sbr = valueValidated.value;
            return 'login';
        }
        if (identificator === IDENTITIES_KEYS_SPECIAL.state && _canStoreSpecial(identificator)) {
            specials.login.state = valueValidated.value;
            return 'login';
        }
        if (identificator === IDENTITIES_KEYS_SPECIAL.login) {
            specials.login = valueValidated.value;
            // setting {login: {rusId: "0"}}
            if (specials.login.rusId !== undefined && specials.login.rusId < 1) {
                delete specials.login.rusId;
            }
            // setting {login: {uid: "0"}}
            if (specials.login.uid !== undefined && specials.login.uid < 1) {
                delete specials.login.uid;
            }
            // setting {login: {rusId: "value"}} -> sets {login: {uid: "value"}}
            if (specials.login.rusId && !specials.login.uid) {
                specials.login.uid = specials.login.rusId;
                delete specials.login.rusId;
            }
            // setting {login: {said: "value"}} -> sets {login: {said: "value", advert_uid: "value"}}
            if (specials.login.said && !specials.login.advert_uid) {
                specials.login.advert_uid = specials.login.said;
            }
            // nothing to update in login object
            if (Object.keys(specials.login).length === 0) {
                return null;
            }
            return 'login';
        }
    }
    return null;
};
